import { INameId } from 'constants/globalTypes'
import { IOpsDepartment, IOpsDepartmentProfile } from 'types/opsDepartments.interface'
import { USE_OPS_MOCKS } from './opsControl'

const KNOWN_PROFILES: IOpsDepartmentProfile[] = [
  { key: 'mining', name: 'Mining', matchNames: ['mining'], kpiTemplate: 'mining', icon: 'pickaxe', sortOrder: 1 },
  { key: 'plant', name: 'Processing Plant', matchNames: ['plant', 'processing', 'processing plant'], kpiTemplate: 'plant', icon: 'factory', sortOrder: 2 },
  { key: 'maintenance', name: 'Maintenance', matchNames: ['maintenance'], kpiTemplate: 'maintenance', icon: 'wrench', sortOrder: 3 },
  { key: 'campServices', name: 'Camp Services', matchNames: ['camp', 'camp services'], kpiTemplate: 'camp', icon: 'home', sortOrder: 4 },
  { key: 'security', name: 'Security', matchNames: ['security'], kpiTemplate: 'security', icon: 'shield', sortOrder: 5 },
]

export const OPS_DEPARTMENTS: IOpsDepartment[] = KNOWN_PROFILES.map((p) => ({
  key: p.key,
  hrDepartmentId: null,
  name: p.name,
  kpiTemplate: p.kpiTemplate,
  icon: p.icon,
  sortOrder: p.sortOrder,
  opsEnabled: true,
}))

const slugKey = (name: string): string =>
  (name || '')
    .replace(/[^a-zA-Z0-9 ]/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word, i) => (i ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word.toLowerCase()))
    .join('')

const matchProfile = (name: string): IOpsDepartmentProfile | undefined => {
  const normalized = (name || '').trim().toLowerCase()
  return KNOWN_PROFILES.find((p) => p.matchNames.includes(normalized))
}

export const resolveOpsDepartments = (hrDepartments: INameId[]): IOpsDepartment[] => {
  const resolved: IOpsDepartment[] = (hrDepartments || []).map((d, i) => {
    const profile = matchProfile(d.name)
    return {
      key: profile ? profile.key : slugKey(d.name) || `department${d.id}`,
      hrDepartmentId: d.id,
      name: d.name,
      kpiTemplate: profile ? profile.kpiTemplate : 'custom',
      icon: profile ? profile.icon : 'clipboard',
      sortOrder: profile ? profile.sortOrder : KNOWN_PROFILES.length + i + 1,
      opsEnabled: true,
    }
  })
  return resolved.sort((a, b) => a.sortOrder - b.sortOrder)
}

export const opsDepartments = (): IOpsDepartment[] =>
  USE_OPS_MOCKS ? [...OPS_DEPARTMENTS].sort((a, b) => a.sortOrder - b.sortOrder) : []

export const deptByKey = (key: string): IOpsDepartment | undefined =>
  OPS_DEPARTMENTS.find((d) => d.key === key)

export const deptName = (key: string): string => {
  const dept = deptByKey(key)
  if (dept) return dept.name
  if (!key) return '—'
  return key.charAt(0).toUpperCase() + key.slice(1)
}
